import { Vue, Component, Prop } from 'vue-property-decorator'
import LinkItem from '~/types/LinkItem'
import ArrowSvg from '~/assets/svg/link-arrow.svg?inline'

@Component
export default class LinkPaginate extends Vue {
  @Prop({ type: Number, required: true })
  readonly pageCount?: number

  @Prop({ type: Number, required: true })
  readonly selected?: number

  @Prop({ type: String, default: 'page' })
  readonly nameQuery: string = 'page'

  @Prop({ type: Number, default: 5 })
  readonly lengthList: number = 5

  get selectedCode (): string {
    return this.paginateList.find((_, i) => i === this.selected)?.code ?? ''
  }

  get paginateList (): LinkItem[] {
    const query = this.$route.query
    const get = (page: number) => (
      {
        code: page.toString(),
        title: page.toString(),
        location: {
          path: this.$route.path,
          query: {
            ...query,
            [this.nameQuery]: page.toString()
          }
        }
      }
    )

    return [...Array(this.pageCount)].map((_, e) => get(e + 1))
  }

  get showList (): LinkItem[] {
    let list = []
    const lengthList = this.lengthList
    const offset = Math.ceil(lengthList / 2)
    const selected = this.selected ?? 0
    const pageCount = this.pageCount ?? 0

    if (pageCount <= lengthList || selected < offset) {
      list = this.paginateList.filter((_, i) => i < lengthList)
    } else if (selected > this.paginateList.length - offset) {
      list = this.paginateList.filter((_, i) => i > this.paginateList.length - 1 - lengthList)
    } else {
      let i = selected - offset
      if (lengthList % 2 !== 0) {
        i += 1
      }
      for (; i < selected + offset; i++) {
        list.push(this.paginateList[i])
      }
    }

    return list
  }

  scrollTo () {
    const elem = document.querySelector('.app__content')
    if (elem) {
      const offset = window.scrollY + elem.getBoundingClientRect().top
      window.scroll({ top: offset, left: 0, behavior: 'smooth' })
    }
  }

  renderFirst () {
    const first = this.paginateList[0]
    if (first && this.selected !== 0) {
      return (
        <nuxt-link {...{
          class: {
            'link-paginate__first': true
          },
          props: {
            to: first.location
          },
          nativeOn: {
            click: () => {
              this.scrollTo()
            }
          }
        }}>
          <ArrowSvg />
          <ArrowSvg />
        </nuxt-link>
      )
    }
  }

  rendetLast () {
    const last = this.paginateList[this.paginateList.length - 1]
    if (last && this.selected !== this.paginateList.length - 1) {
      return (
        <nuxt-link {...{
          class: {
            'link-paginate__last': true
          },
          props: {
            to: last.location
          },
          nativeOn: {
            click: () => {
              this.scrollTo()
            }
          }
        }}>
          <ArrowSvg />
          <ArrowSvg />
        </nuxt-link>
      )
    }
  }

  renderPrev () {
    const prev = this.paginateList[(this.selected ?? 0) - 1]
    if (prev) {
      return (
        <nuxt-link {...{
          class: {
            'link-paginate__prev': true
          },
          props: {
            to: prev.location
          },
          nativeOn: {
            click: () => {
              this.scrollTo()
            }
          }
        }}>
          <ArrowSvg />
        </nuxt-link>
      )
    }
  }

  renderNext () {
    const next = this.paginateList[(this.selected ?? 0) + 1]
    if (next) {
      return (
        <nuxt-link {...{
          class: {
            'link-paginate__next': true
          },
          props: {
            to: next.location
          },
          nativeOn: {
            click: () => {
              this.scrollTo()
            }
          }
        }}>
          <ArrowSvg />
        </nuxt-link>
      )
    }
  }

  renderList () {
    return (
      <div class="link-paginate__list">
        {this.showList.map(e => (
          <nuxt-link {...{
            class: {
              'link-paginate__item': true,
              'link-paginate__item_selected': this.selectedCode === e.code,
              'link-paginate__item_large': parseInt(e.code ?? '0', 10) > 99
            },
            props: {
              to: e.location
            },
            nativeOn: {
              click: () => {
                this.scrollTo()
              }
            }
          }}>
            {e.title}
          </nuxt-link>
        ))}
      </div>
    )
  }

  render () {
    return (
      <div class="link-paginate">
        {this.renderFirst()}
        {this.renderPrev()}
        {this.renderList()}
        {this.renderNext()}
        {this.rendetLast()}
      </div>
    )
  }
}
